(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
(() => {
  if (window.KingSpellsPersonalization) return;

  const panelSelector = '[data-ks-personalization]';
  const fieldSelector = '[data-ks-personalization-field]';
  const checkoutSelector = '.cart__dynamic-checkout-buttons';
  const checkoutState = new WeakMap();
  let state;
  let timer;
  let nativeSubmit = false;

  const panel = () => document.querySelector(panelSelector);
  const fields = () => Array.from(panel()?.querySelectorAll(fieldSelector) || []);
  const values = () => Object.fromEntries(fields().map((field) => [field.dataset.attribute, field.value]));
  const dirty = (cart = state) => cart && Object.keys(cart.values).some((key) => cart.values[key] !== cart.saved[key]);
  const busy = () => Boolean(state && (state.pending || state.submitting || (state.active && dirty())));

  function syncCheckout() {
    document.querySelectorAll(checkoutSelector).forEach((element) => {
      if (busy()) {
        if (!checkoutState.has(element)) {
          checkoutState.set(element, { inert: element.inert, aria: element.getAttribute('aria-busy') });
        }
        element.inert = true;
        element.setAttribute('aria-busy', 'true');
      } else if (checkoutState.has(element)) {
        const previous = checkoutState.get(element);
        element.inert = previous.inert;
        if (previous.aria === null) element.removeAttribute('aria-busy');
        else element.setAttribute('aria-busy', previous.aria);
        checkoutState.delete(element);
      }
    });
  }

  function renderStatus() {
    const container = panel();
    if (container && state) {
      const status = container.querySelector('[data-ks-personalization-status]');
      const mode = state.error ? 'error' : busy() ? 'saving' : state.didSave ? 'saved' : '';
      const message = mode ? container.dataset[mode] || '' : '';
      container.dataset.saveState = mode;
      if (status && status.textContent !== message) status.textContent = message;
    }
    syncCheckout();
  }

  function mount() {
    const container = panel();
    if (!container) {
      if (state) state.active = false;
      clearTimeout(timer);
      syncCheckout();
      return;
    }
    const token = container.dataset.ksCartToken;
    if (!state || state.token !== token) {
      clearTimeout(timer);
      const initial = values();
      state = { token, values: initial, saved: { ...initial }, active: true, pending: null, error: false, didSave: false, submitting: false };
    }
    state.active = true;
    container.hidden = false;
    fields().forEach((field) => {
      field.disabled = false;
      field.value = state.values[field.dataset.attribute] ?? '';
    });
    renderStatus();
  }

  function capture() {
    if (!state?.active || !panel()) return;
    state.values = values();
  }

  function queueSave(delay = 400) {
    clearTimeout(timer);
    renderStatus();
    if (state?.active && !state.submitting && dirty()) timer = setTimeout(save, delay);
  }

  function save() {
    clearTimeout(timer);
    const cart = state;
    if (!cart?.active || cart.submitting || !dirty(cart)) return Promise.resolve();
    if (cart.pending) return cart.pending;
    cart.error = false;
    cart.pending = (async () => {
      while (cart === state && cart.active && !cart.submitting && dirty(cart)) {
        const snapshot = { ...cart.values };
        try {
          const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: snapshot }),
          });
          if (!response.ok) throw new Error('Cart details could not be saved.');
          const result = await response.json();
          if (result.errors || Object.keys(snapshot).some((key) => (result.attributes?.[key] ?? '') !== snapshot[key])) {
            throw new Error('Cart details were not confirmed.');
          }
          cart.saved = snapshot;
          cart.didSave = true;
        } catch (_) {
          cart.error = true;
          break;
        }
      }
    })().finally(() => {
      cart.pending = null;
      if (cart === state) renderStatus();
    });
    renderStatus();
    return cart.pending;
  }

  function afterCartRender(sectionHTML) {
    const source = new DOMParser().parseFromString(sectionHTML, 'text/html').querySelector(panelSelector);
    let current = panel();
    if (!source) {
      clearTimeout(timer);
      if (state) state.active = false;
      if (current) {
        current.hidden = true;
        fields().forEach((field) => { field.disabled = true; });
      }
      renderStatus();
      return;
    }
    if (!current) {
      const items = document.querySelector('#cart #main-cart-items');
      if (!items) return;
      items.after(source);
      current = source;
    } else if (current.dataset.ksCartToken !== source.dataset.ksCartToken) {
      current.replaceWith(source);
    }
    mount();
    if (dirty() && !state.error) queueSave(0);
  }

  function onFieldEdit(event) {
    if (!event.target.matches(fieldSelector) || !event.target.closest(panelSelector)) return;
    capture();
    state.error = false;
    queueSave(event.type === 'change' ? 0 : 400);
  }

  document.addEventListener('input', onFieldEdit);
  document.addEventListener('change', onFieldEdit);

  document.addEventListener('submit', async (event) => {
    if (event.target.id !== 'cart' || nativeSubmit || !state?.active) return;
    capture();
    clearTimeout(timer);
    if (!state.pending && !dirty()) return;
    event.preventDefault();
    if (state.submitting) return;
    const cart = state;
    const submitter = event.submitter;
    cart.submitting = true;
    renderStatus();

    if (cart.pending) await cart.pending;
    const form = document.getElementById('cart');
    if (!form || state !== cart || !cart.active) {
      cart.submitting = false;
      renderStatus();
      return;
    }
    capture();
    cart.submitting = false;
    const button = submitter?.form === form ? submitter : submitter?.id ? document.getElementById(submitter.id) : null;
    nativeSubmit = true;
    try {
      if (!submitter || button?.form === form) {
        form.requestSubmit(button || undefined);
      } else {
        if (submitter.name) {
          const hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = submitter.name;
          hidden.value = submitter.value;
          form.appendChild(hidden);
        }
        HTMLFormElement.prototype.submit.call(form);
      }
    } finally {
      nativeSubmit = false;
      renderStatus();
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (busy() && event.target.closest?.(checkoutSelector)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  new MutationObserver(syncCheckout).observe(document.documentElement, { childList: true, subtree: true });

  (() => {
    const viewport = window.visualViewport;
    const isMobile = () => window.matchMedia('(pointer: coarse)').matches;
    const isField = (element) => element?.matches?.('[data-ks-personalization-field]') && element.closest('[data-ks-personalization]');
    const isEditable = (element) => element?.isContentEditable || element?.matches?.('textarea, select') ||
      (element?.tagName === 'INPUT' && !/^(button|submit|reset|checkbox|radio|range|color|file|hidden|image)$/i.test(element.type));
    const height = () => viewport ? viewport.height * (viewport.scale || 1) : window.innerHeight;
    const position = () => ({ x: viewport?.pageLeft ?? window.scrollX, y: viewport?.pageTop ?? window.scrollY });
    let restingHeight = height();
    let session;
    let pointerStart;
    let settleTimer;
    let limitTimer;
    let keyboardTimer;
    let viewportSnapshot;
    const timers = new Set();

    const later = (callback, delay) => {
      const timer = setTimeout(() => { timers.delete(timer); callback(); }, delay);
      timers.add(timer);
      return timer;
    };

    function stopTimers() {
      timers.forEach(clearTimeout);
      timers.clear();
    }

    function restoreViewport() {
      if (viewportSnapshot && viewportSnapshot.element.getAttribute('content') === viewportSnapshot.temporary) {
        if (viewportSnapshot.content === null) viewportSnapshot.element.removeAttribute('content');
        else viewportSnapshot.element.setAttribute('content', viewportSnapshot.content);
      }
      viewportSnapshot = undefined;
    }

    function cancelReturn(keepSession = false) {
      stopTimers();
      restoreViewport();
      if (keepSession && session) {
        session.finishing = false;
        session.returning = false;
      } else {
        session = undefined;
      }
    }

    function normalScale() {
      if (viewport && viewport.scale <= 1.01) return;
      const element = document.querySelector('meta[name="viewport"]');
      if (!element) return;
      const content = element.getAttribute('content');
      const settings = (content || '').split(',').map((part) => part.trim())
        .filter((part) => part && !/^(initial-scale|minimum-scale|maximum-scale)\s*=/i.test(part));
      const temporary = [...settings, 'initial-scale=1', 'minimum-scale=1', 'maximum-scale=1'].join(', ');
      viewportSnapshot = { element, content, temporary };
      element.setAttribute('content', temporary);
    }

    function returnToPage() {
      stopTimers();
      if (!session || !isMobile() || isEditable(document.activeElement) || document.visibilityState === 'hidden') {
        cancelReturn();
        return;
      }
      const current = session;
      current.returning = true;
      normalScale();
      const restorePosition = () => {
        if (session === current && !isEditable(document.activeElement)) {
          window.scrollTo({ left: current.x, top: current.y, behavior: 'instant' });
        }
      };
      restorePosition();
      later(restorePosition, 100);
      later(restorePosition, 320);
      later(() => {
        if (session !== current) return;
        restoreViewport();
        restorePosition();
        session = undefined;
        restingHeight = height();
      }, 600);
    }

    function finishEditing() {
      if (!session || session.finishing) return;
      session.finishing = true;
      clearTimeout(keyboardTimer);
      settleTimer = later(returnToPage, 400);
      limitTimer = later(returnToPage, 1600);
    }

    function onResize() {
      if (!session) {
        if (!isEditable(document.activeElement)) restingHeight = height();
        return;
      }
      if (session.returning) return;
      const visibleHeight = height();
      if (visibleHeight < session.height - Math.max(110, session.height * 0.18)) session.keyboardSeen = true;
      if (session.finishing) {
        clearTimeout(settleTimer);
        settleTimer = later(returnToPage, 220);
        return;
      }
      clearTimeout(keyboardTimer);
      if (session.keyboardSeen && visibleHeight >= session.height - 80 && isField(document.activeElement)) {
        const current = session;
        keyboardTimer = later(() => {
          if (session !== current || height() < current.height - 80 || !isField(document.activeElement)) return;
          document.activeElement.blur();
          finishEditing();
        }, 160);
      }
    }

    document.addEventListener('pointerdown', (event) => {
      if (!isMobile()) return;
      if (isField(event.target)) {
        if (session?.finishing) cancelReturn(true);
        pointerStart = { ...position(), height: Math.max(restingHeight, height()), field: event.target, at: Date.now() };
      } else if (session?.finishing) {
        cancelReturn();
      }
    }, true);

    document.addEventListener('focusin', (event) => {
      if (!isMobile()) return;
      if (isField(event.target)) {
        cancelReturn(true);
        if (!session) {
          const start = pointerStart?.field === event.target && Date.now() - pointerStart.at < 1500 ? pointerStart :
            { ...position(), height: Math.max(restingHeight, height()) };
          session = { x: start.x, y: start.y, height: start.height, keyboardSeen: false, finishing: false, returning: false };
        }
        pointerStart = undefined;
      } else if (isEditable(event.target)) {
        cancelReturn();
      }
    });

    document.addEventListener('focusout', (event) => {
      if (!isField(event.target) || !isMobile()) return;
      if (isField(event.relatedTarget)) cancelReturn(true);
      else if (isEditable(event.relatedTarget)) cancelReturn();
      else finishEditing();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || event.isComposing || !isMobile() || !isField(event.target) || event.target.tagName !== 'INPUT') return;
      event.preventDefault();
      event.target.blur();
      finishEditing();
    });

    document.addEventListener('wheel', () => { if (session?.finishing) cancelReturn(); }, { passive: true });
    document.addEventListener('touchmove', () => { if (session?.finishing) cancelReturn(); }, { passive: true });
    document.addEventListener('submit', () => cancelReturn(), true);
    document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') cancelReturn(); });
    viewport?.addEventListener('resize', onResize);
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', () => { cancelReturn(); restingHeight = height(); });
    window.addEventListener('pagehide', () => cancelReturn());
  })();

  window.KingSpellsPersonalization = { beforeCartRender: capture, afterCartRender };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();

  } catch(e) { console.error(e); }
})();
})();
